import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  type DeleteDocumentExternalFilesDeleteRequestType,
  deleteDocumentExternalFilesDelete,
} from '..';
import { queryKey } from './query-key';

export const useDeleteDocumentExternalFilesDelete = () => {
  const queryClient = useQueryClient();

  const onSuccess = async (
    _data: unknown,
    variables: DeleteDocumentExternalFilesDeleteRequestType,
  ) => {
    await queryClient.refetchQueries(queryKey.document(variables.documentId));
    await queryClient.refetchQueries(
      queryKey.documentsExternalFiles(variables.documentId),
    );
  };

  return useMutation({
    mutationFn: deleteDocumentExternalFilesDelete,
    onSuccess,
  });
};
